//let baseUrl = 'http://localhost/myriset-yii/api/web/index.php/';
let baseUrl = 'https://rest.myriset.com/';
//let baseUrl = 'https://backup.rest.myriset.com/';
//let baseUrl = 'https://rest.survey2.myriset.com/';
//let baseUrl = 'https://api.survey.telekomatika.id/';

export default {   
  rest    :  baseUrl + 'v01/',          
  title   :  'Survey App',
  prefix  :  'svy',        
  
  /*file    :  function(route, id){
    return baseUrl + 'frontend/web/index.php/site/' + route + '?referer='+btoa(AndroidOrigin)+'&refd='+btoa(id);   
  }, */
  theme   : {
    primaryColor : 'cyan',//*/'yellow darken-2',
    accentColor  : 'pink'//*/'red',
  }
}
